module.exports = __webpack_public_path__ + "img/resources-768.a4673d19.jpg";